import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
// 引入 element ui
import locale from 'element-ui/lib/locale/lang/zh-CN'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
// 工作流
import JeeplusFlow from 'jeeplus-flowable'
import 'jeeplus-flowable/lib/jeeplus-flowable.css'
import FormMaking from 'jeeplus-form/dist/JpFormMaking.common'
import 'jeeplus-form/dist/JpFormMaking.css'
// 引入自定义全局插件
import './directive'
import 'font-awesome/css/font-awesome.min.css'
import flowableRequest from '@/utils/flowableRequest'
Vue.use(ElementUI, { locale })
Vue.use(JeeplusFlow)
Vue.use(FormMaking)
Vue.prototype.$http = flowableRequest
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
